<template>
  <table v-if="this.modo">
    <tr v-if="modo === 'evitar'" style="font-size: medium">
      <td>
        <span class="badge" style="color: black; background: white"
          >Suspensiones:
        </span>
      </td>
      <td>
        <span
          class="badge"
          style="
            border: solid rgb(63, 62, 62) 1px;
            color: black;
            background: white;
          "
          >A tratar</span
        >
      </td>
      <td>
        <span
          class="badge"
          style="
            border: solid rgb(63, 62, 62) 1px;
            color: black;
            background: rgb(162, 255, 134, 0.5);
          "
          >Resueltos</span
        >
      </td>
      <td>
        <span
          class="badge"
          style="
            border: solid rgb(63, 62, 62) 1px;
            color: black;
            background: rgb(216, 0, 50, 0.5);
          "
          >Acceso suspendido</span
        >
      </td>
    </tr>
    <tr v-else style="font-size: medium">
      <td>
        <span class="badge" style="color: black; background: white"
          >Suspensiones:
        </span>
      </td>
      <td>
        <span
          class="badge"
          style="
            border: solid rgb(63, 62, 62) 1px;
            color: black;
            background: white;
          "
          >A tratar</span
        >
      </td>
      <td>
        <span
          class="badge"
          style="
            border: solid rgb(63, 62, 62) 1px;
            color: black;
            background: rgb(162, 255, 134, 0.5);
          "
          >Resueltos</span
        >
      </td>
    </tr>
  </table>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "ReferenciaDeColoresSuspensiones",
  computed: {
    modo() {
      return this.$store.state.Suspensiones.suspensionesMODO;
    },
  },
});
</script>
